import { Equals, IsString } from 'class-validator';

import { BaseRule } from './base-rule';
import { FilterType } from './consts';

export class TextRule extends BaseRule {
  constructor() {
    super();
    this.type = FilterType.TEXT;
    this.value = '';
  }

  @Equals(FilterType.TEXT)
  type: FilterType.TEXT;

  @IsString()
  value: string;
}
